import React, { useEffect, useState } from "react";
import Loading from "../layout/Loading";
import Moment from "react-moment";
import "moment-timezone";
import moment from "moment/min/moment-with-locales";

const MatchScore = (props) => {
  const [loading, setLoading] = useState(false);
  const [match, setMatch] = useState({});
  const [leage, setLeage] = useState({});
  const [localteam, setLocalteam] = useState({});
  const [visitorTeam, setVisitorTeam] = useState({});
  const [scores, setScores] = useState({});
  const [time, setTime] = useState({});
  const [startingat, setStartingat] = useState({});
  const [statistics, setStatistics] = useState({});
  const [statisticsfirst, setStatisticsfirst] = useState({});
  const [statisticssecond, setStatisticssecond] = useState({});
  const [season, setSeason] = useState(17504);
  const [livestanding, setLivestanding] = useState([]);
  const [display, setDisplay] = useState(true);
  const [lineup, setLineup] = useState([]);
  const [lineupdata, setLineupdata] = useState(false);
  const [visitorteamlineup, setVisitorteamlineup] = useState(false);
  const [localteamlineup, setLocalteamlineup] = useState(true);
  const [fixture, setFixture] = useState({});
  const [tvstation, setTvstation] = useState([]);
  const [tvstationshow, setTvstationshow] = useState(true);

  useEffect(() => {
    const fetchdata = () => {
      fetch(
        `${process.env.REACT_APP_API_FOOTBALL}/fixtures/${props.match.params.fid}?api_token=${process.env.REACT_APP_API_TOKEN}&include=localTeam,visitorTeam,league,lineup,stats`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }
      )
        .then((res) => {
          return res.json();
        })
        .catch((err) => {
          console.log(err);
        })
        .then((data) => {
          setMatch(data.data);
          setLeage(data.data.league.data);
          setLocalteam(data.data.localTeam.data);
          setVisitorTeam(data.data.visitorTeam.data);
          setScores(data.data.scores);
          setTime(data.data.time);
          setStartingat(data.data.time.starting_at);
          setSeason(data.data.season_id);
          setLineup(data.data.lineup.data);
          setFixture(data.data.id);
        });
    };
    fetchdata();

    fetch(
      `${process.env.REACT_APP_API_FOOTBALL}/fixtures/${props.match.params.fid}?api_token=${process.env.REACT_APP_API_TOKEN}&include=stats`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    )
      .then((res) => res.json())
      .then((data) => {
        return (
          setStatistics(data.data.stats.data),
          setStatisticsfirst(data.data.stats.data[0]),
          setStatisticssecond(data.data.stats.data[1])
        );
      });

    fetch(
      `${process.env.REACT_APP_API_FOOTBALL}/standings/season/live/${season}?api_token=${process.env.REACT_APP_API_TOKEN}&include=team`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    )
      .then((res) => res.json())
      .then((data) => {
        return setLivestanding(data.data);
      });

    fetch(
      `${process.env.REACT_APP_API_FOOTBALL}/tvstations/fixture/${fixture}?api_token=${process.env.REACT_APP_API_TOKEN}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    )
      .then((res) => res.json())
      .then((data) => {
        return setTvstation(data.data);
      });
  }, [match]);

  const found = () => {
    setLoading(true);
    fetch(
      `${process.env.REACT_APP_API_FOOTBALL}/fixtures/${props.match.params.fid}?api_token=${process.env.REACT_APP_API_TOKEN}&include=stats`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    )
      .then((res) => res.json())
      .then((data) => {
        return (
          setStatistics(data.data.stats.data),
          setLoading(false),
          setStatisticsfirst(data.data.stats.data[0]),
          setStatisticssecond(data.data.stats.data[1]),
          setDisplay(true),
          setLineupdata(false),
          setTvstationshow(false)
        );
      });
  };

  const standing = async () => {
    setLoading(true);
    await fetch(
      `${process.env.REACT_APP_API_FOOTBALL}/standings/season/live/${season}?api_token=${process.env.REACT_APP_API_TOKEN}&include=team`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    )
      .then((res) => res.json())
      .then((data) => {
        return (
          setLivestanding(data.data),
          setDisplay(false),
          setLoading(false),
          setLineupdata(false)
        );
      });
  };

  const home = () => {
    return setDisplay(true), setLineupdata(false), setTvstationshow(true);
  };

  const lineupd = () => {
    return setLineupdata(true);
  };

  const visitorteam = () => {
    return setVisitorteamlineup((value) => !value), setLocalteamlineup(false);
  };

  const localteamline = () => {
    return setLocalteamlineup((value) => !value), setVisitorteamlineup(false);
  };

  const showloading = () =>
    loading && (
      <div className="d-flex justify-content-center">
        <Loading />
      </div>
    );

  return (
    <>
      {" "}
      <div className="container">
        <div class="card card-curve p-3 ">
          <span>
            {" "}
            <img src={`${leage.logo_path}`} width="50px" alt="logo" />{" "}
            {leage.name}
          </span>
          <span>
            {" "}
            <h4 className="font-weight-bold">
              {localteam.name} VS {visitorTeam.name}
            </h4>{" "}
            LIVE SCORE{" "}
          </span>

          <div className="bg-white">
            <div className="row mt-5 ">
              <div className="col-sm-5 mb-5">
                <h4 className="text-center">
                  <img src={localteam.logo_path} width="60px" alt="" />
                  {localteam.name}
                </h4>
              </div>

              <div className="col-sm-2 mt-2">
                <span className="text-center">
                  <h3>
                    {" "}
                    <span className="bg-primary p-3 text-white card-curve">
                      {" "}
                      {scores.localteam_score}
                    </span>{" "}
                    <span className="bg-primary p-3 text-white card-curve">
                      {" "}
                      {scores.visitorteam_score}
                    </span>
                  </h3>
                  <br />
                  <p className="text-center">
                    {" "}
                    {time.minute}{" "}
                    {time.second ? <span>: {time.second}</span> : ""}
                  </p>
                </span>

                {/* <Moment unix tz="Asia/Calcutta|Asia/Kolkata">
                {startingat.timestamp}
              </Moment> */}
              </div>
              <div className="col-sm-5">
                <h2 className="text-center">
                  <img src={visitorTeam.logo_path} width="60px" alt="" />
                  {visitorTeam.name}
                </h2>{" "}
              </div>
            </div>

            <p className="text-center text-muted mt-5">
              {" "}
              <i class="far fa-clock"></i>{" "}
              <Moment unix>{startingat.timestamp}</Moment>
            </p>
          </div>
          {/* Match details header */}
          <div className="text-center mt-3">
            <button
              type="button"
              className="btn btn-raised btn-primary mr-3"
              onClick={(area) => home()}
            >
              HOME
            </button>
            <button
              type="button"
              className="btn btn-raised btn-primary mr-3"
              onClick={(area) => lineupd()}
            >
              LINE-UP
            </button>
            <button
              type="button"
              className="btn btn-raised btn-primary mr-3"
              onClick={(area) => found()}
            >
              STATISTICS
            </button>
            <button
              type="button"
              className="btn btn-raised btn-primary"
              onClick={(area) => standing()}
            >
              LIVE STANDINGS
            </button>
          </div>

          <hr />
          {showloading()}
          {lineupdata ? (
            <div>
              <div className="text-center">
                {" "}
                <button
                  className="btn bg-secondary mr-3 text-white"
                  onClick={() => localteamline()}
                >
                  {" "}
                  {localteam.name}
                </button>
                {"  "}
                <button
                  className="btn bg-success text-white"
                  onClick={(area) => visitorteam()}
                >
                  {" "}
                  {visitorTeam.name}
                </button>
              </div>
              <div className="row">
                {localteamlineup ? (
                  <div className="offset-sm-3 col-sm-6 ">
                    {lineup
                      .filter((i, index) => index < 11)
                      .map((data) => {
                        return (
                          <div
                            className="card bg-secondary text-white shadow-sm border-0 p-4"
                            key={data.number}
                          >
                            <p>
                              <span className="font-weight-bold text-white display-4">
                                {" "}
                                {data.number}
                              </span>{" "}
                              <span className="font-weight-bold">
                                {" "}
                                {data.player_name}
                              </span>{" "}
                            </p>
                          </div>
                        );
                      })}
                  </div>
                ) : (
                  ""
                )}
                {visitorteamlineup ? (
                  <div className="offset-sm-3 col-sm-6">
                    {lineup.slice(11, 23).map((data) => {
                      return (
                        <div
                          className="card bg-success text-white shadow-sm border-0 p-4"
                          key={data.number}
                        >
                          <p>
                            <span className="font-weight-bold text-white display-4">
                              {" "}
                              {data.number}
                            </span>{" "}
                            <span className="font-weight-bold">
                              {" "}
                              {data.player_name}
                            </span>{" "}
                          </p>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          ) : (
            <>
              {display ? (
                <div className="container  rounded-sm">
                  {statisticsfirst === undefined ? (
                    ""
                  ) : (
                    <>
                      {tvstationshow ? (
                        <>
                          {" "}
                          <div className="card p-4">
                            {" "}
                            <h3 className="text-center p-3">
                              TV Stations
                            </h3>{" "}
                            <div className="row">
                              {tvstation.map((data) => {
                                return (
                                  <div className="col-sm-2 mt-2">
                                    <span class="badge badge-pill badge-info p-2">
                                      {data.tvstation}
                                    </span>
                                  </div>
                                );
                              })}{" "}
                            </div>{" "}
                          </div>
                        </>
                      ) : (
                        ""
                      )}
                      {statisticsfirst.fouls === null ? (
                        ""
                      ) : (
                        <span className="text-muted text-center">
                          {" "}
                          <h4>Fouls</h4>
                          <h2>
                            <span className="bg-statistic">
                              {" "}
                              {statisticsfirst.fouls}
                            </span>{" "}
                            -{" "}
                            <span className="bg-statistic">
                              {statisticssecond.fouls}
                            </span>
                          </h2>
                        </span>
                      )}

                      {/*Fouls */}

                      {statisticsfirst.corners === null ? (
                        ""
                      ) : (
                        <span className="text-muted text-center">
                          <h4>Corners</h4>
                          <h2>
                            <span className="bg-statistic">
                              {" "}
                              {statisticsfirst.corners}
                            </span>{" "}
                            -{" "}
                            <span className="bg-statistic">
                              {statisticssecond.corners}
                            </span>
                          </h2>
                        </span>
                      )}

                      {/* Corners*/}

                      {statisticsfirst.saves === null ? (
                        ""
                      ) : (
                        <span className="text-muted text-center">
                          <h4>Saves</h4>
                          <h2>
                            <span className="bg-statistic">
                              {" "}
                              {statisticsfirst.saves}{" "}
                            </span>{" "}
                            -{" "}
                            <span className="bg-statistic">
                              {statisticssecond.saves}
                            </span>
                          </h2>
                        </span>
                      )}

                      {/* saves*/}

                      {statisticsfirst.throw_in === null ? (
                        ""
                      ) : (
                        <span className="text-muted text-center">
                          <h4>Throw-Ins</h4>
                          <h2>
                            <span className="bg-statistic">
                              {" "}
                              {statisticsfirst.throw_in}{" "}
                            </span>{" "}
                            -{" "}
                            <span className="bg-statistic">
                              {statisticssecond.throw_in}
                            </span>
                          </h2>
                        </span>
                      )}

                      {/* Throw-Ins*/}

                      {statisticsfirst.free_kick === null ? (
                        ""
                      ) : (
                        <span className="text-muted text-center">
                          <h4>Free Kicks</h4>
                          <h2>
                            <span className="bg-statistic">
                              {" "}
                              {statisticsfirst.free_kick}{" "}
                            </span>{" "}
                            -{" "}
                            <span className="bg-statistic">
                              {statisticssecond.free_kick}
                            </span>
                          </h2>
                        </span>
                      )}

                      {/* Free Kicks*/}

                      {statisticsfirst.yellowcards === null ? (
                        ""
                      ) : (
                        <>
                          <span className="text-muted text-center">
                            <h4>Yellow Cards</h4>
                            <h2>
                              <span className="bg-statistic">
                                {" "}
                                {statisticsfirst.yellowcards}{" "}
                              </span>
                              -{" "}
                              <span className="bg-statistic">
                                {statisticssecond.yellowcards}
                              </span>
                            </h2>
                          </span>
                        </>
                      )}

                      {/*Yellow Cards*/}
                    </>
                  )}
                </div>
              ) : (
                <>
                  {livestanding === undefined ? (
                    ""
                  ) : (
                    <>
                      {livestanding.map((data) => {
                        return (
                          <div
                            className="card rounded-0 shadow-sm border-0 p-4"
                            key={data.position}
                          >
                            <p>
                              <span className="font-weight-bold">
                                {" "}
                                {data.position}
                              </span>{" "}
                              <img
                                width="30px"
                                src={`${data.team_logo}`}
                                alt=""
                              />{" "}
                              {data.team_name}
                              <span className="float-right">
                                {data.played}
                                {"  "}
                                <span className="rounded-circle p-2 font-weight-bold border ">
                                  {data.points}
                                </span>
                              </span>
                            </p>
                            <p>
                              <span class="badge badge-pill badge-success">
                                {data.wins}W
                              </span>{" "}
                              <span class="badge badge-pill badge-warning">
                                {data.draws}D
                              </span>{" "}
                              <span class="badge badge-pill badge-danger">
                                {data.lost}L
                              </span>{" "}
                              <img src="https://img.icons8.com/emoji/20/000000/soccer-ball-emoji.png" />{" "}
                              <span class="badge badge-pill badge-info">
                                {data.goals}
                              </span>
                            </p>
                          </div>
                        );
                      })}
                    </>
                  )}
                </>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default MatchScore;
